interface StatusProp {
    status: boolean,
    title: string
}

export default function StatusComponent({status, title}: StatusProp) {
    return (
        <p className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${status ? 'bg-green-50 text-green-700 ring-green-600/20 dark:bg-green-500/10 dark:text-green-400' : 'bg-red-50 text-red-700 ring-red-600/10 dark:ext-red-400 dark:bg-red-400/20'}`}>
            {title}
        </p>
    )
}
